export default {
  name: 'AppBar',
  displayName: {
    en: 'Top Bar',
    ja: 'トップ',
  },
  componentType: 'appBar',
  icon: './icon.png',
  defaultWidth: 375,
  defaultHeight: 60,
  snappingRules: {
    snap: true,
    snapType: 'screenEdge',
    lock: {
      left: 0,
      right: 0,
      top: 20,
    },
  },
  resizeX: true,
  props: [],
  childComponents: [
    {
      name: 'leftIcon',
      displayName: {
        en: 'Left Icon',
        ja: '左アイコン',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'arrow-back',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      actions: true,
      dataBindings: true,
      dataBindingDataTypes: ['text'],
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Screen Title',
          disableDynamicValues: true,
          enabled: {
            titleType: ['logo', 'CLICK_INTERNAL_!previous'],
          },
        },
      ],
    },
    {
      name: 'rightIcon1',
      displayName: {
        en: 'Right Icon 1',
        ja: '右アイコン1',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'arrow-back',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
    {
      name: 'rightIcon2',
      displayName: {
        en: 'Right Icon 2',
        ja: '右アイコン2',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'arrow-back',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
  ],
  style: {
    text: true,
    border: true,
    backgroundColor: true,
    color: true,
    opacity: true,
  },
};
